import * as R from 'fp-ts/Record';
import * as A from 'fp-ts/Array';
import * as F from 'fp-ts/function';
import { produce } from "immer";
import { EditMode } from "../state/uiState";
export function mealyInitExecutionState(mealyMachine) {
    const node = Object.values(mealyMachine.nodes).find(node => node.isStart);
    if (node === undefined) {
        throw new Error('No start state');
    }
    return {
        currentNode: node,
        lastChar: '',
        lastTransition: null,
        lastCharIndex: 0,
        lastTransitionOutput: '',
    };
}
const transition_startsAtNode = (fromNodeId) => (transition) => transition.fromNodeId === fromNodeId;
const flatTransition_hasChar = (char) => (flatTransition) => flatTransition.char === char;
function transition_toFlatTransitions(transition) {
    return transition.singleTransitions.map((char, index) => ({
        transitionId: transition.id,
        fromNodeId: transition.fromNodeId,
        toNodeId: transition.toNodeId,
        char: char.char,
        charIndex: index,
        output: char.output,
    }));
}
export function mealyExecuteStep(mealyMachine, mealyExecutionState, currentChar) {
    const currentNode = mealyExecutionState.currentNode;
    const flatTransitions = F.pipe(mealyMachine.transitions, R.filter(transition_startsAtNode(currentNode.id)), Object.values, A.map(transition_toFlatTransitions), A.flatten, A.filter(flatTransition_hasChar(currentChar)));
    const flatTransition = flatTransitions[0];
    if (flatTransition === undefined) {
        // throw new Error('No transition');
        return [mealyExecutionState, false];
    }
    const nextNode = mealyMachine.nodes[flatTransition.toNodeId];
    return [{
            currentNode: nextNode,
            lastChar: currentChar,
            lastCharIndex: flatTransition.charIndex,
            lastTransition: mealyMachine.transitions[flatTransition.transitionId],
            lastTransitionOutput: flatTransition.output,
        }, true];
}
export function mealyStartAnimation(machineState) {
    return produce(machineState, draftMachineState => {
        const newExecutionState = draftMachineState.executionState;
        draftMachineState.uiState.editMode = EditMode.EXECUTION_TRANSITION;
        draftMachineState.animation.char = newExecutionState.lastChar;
        draftMachineState.animation.charIndex = newExecutionState.lastCharIndex;
        draftMachineState.animation.transitionId = newExecutionState.lastTransition.id;
        // timeline wäre wohl besser, da alle requestAnimationFrame-Callbacks, die direkt nacheinander laufen, den gleichen Wert für currenTime bekommen
        // draftMachineState.animation.startTimestamp = <number>document.timeline.currentTime;
        draftMachineState.animation.startTimestamp = performance.now();
        draftMachineState.animation.progress = 0;
    });
}
export const callIfExecuted = (f) => ([x, hasBeenExecuted]) => {
    if (hasBeenExecuted) {
        return [f(x), hasBeenExecuted];
    }
    else {
        return [x, hasBeenExecuted];
    }
};
export const startAnimationIfExecuted = callIfExecuted(mealyStartAnimation);
